import { render, staticRenderFns } from "./GlossDetailsScreen.vue?vue&type=template&id=3f6b52c7&"
import script from "./GlossDetailsScreen.vue?vue&type=script&lang=ts&"
export * from "./GlossDetailsScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports